var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLegallink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55908 5.85004V5.1213L13.3606 4.75195V6.41403L8.55908 5.85004Z",
    fill: "#2B2B2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0188 9.18406C3.51127 9.06094 3.94218 8.81477 5.41958 9.18406C6.57737 9.47346 7.3279 9.24561 7.82036 8.99938",
    stroke: "#2B2B2B",
    strokeWidth: 0.923378
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12671 4.62877L5.41944 4.01318L6.71217 4.62877V6.04468H4.12671V4.62877Z",
    stroke: "#2B2B2B",
    strokeWidth: 0.923378
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65967 7.15259H7.17151V8.07597H3.65967V7.15259Z",
    fill: "#2B2B2B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6828 3.28065L5.41951 0.728027L0.15625 3.28065V10.2411L5.41951 13.2303L10.6828 10.2411V7.64893L9.39003 7.16415V9.44053L5.41951 11.7863L1.44898 9.44053V4.14395L5.41951 2.12756L9.36638 4.13194L10.6828 3.3092V3.28065Z",
    fill: "#2B2B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLegallink);
export default __webpack_public_path__ + "static/media/icon-legallink.a7d21efd3d917a44b1c4db84f7edc399.svg";
export { ForwardRef as ReactComponent };